import React, { Component } from 'react';
import { connect } from 'dva';
import { Radio, Select, Input, Tooltip, Icon } from 'antd';
import Contanner from '../../../../components/Container';
import SchoolAddress from './School';
import CountyAddress from './County/index';
import styles from './index.less';

const { Option } = Select;
const { Search } = Input;

@connect(({ contactsList }) => ({
  ...contactsList,
}))
class BaseList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/reset',
    });
    dispatch({
      type: 'contactsList/fetchSchoolTreeList',
    });
    dispatch({
      type: 'contactsList/isAdmin',
    });
  }

  handleTypeChange = e => {
    const currentType = e.target.value;
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        addressType: currentType,
      },
    });
  };

  countySelectOptionChange = value => {
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/fetchCountyTreeList',
      params: {
        viewDeptId: value,
      },
    });
  };

  countyOnSearch = value => {
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/fetchCountyTreeList',
      params: {
        searchField: value,
      },
    });
  };

  render() {
    const { addressType, isAdmin, orgStructList } = this.props;
    return (
      <Contanner breStates={!0} version={2}>
        <div className={styles['contacts-list']}>
          <div className="optionsWrap">
            {isAdmin === 1 && (
              <Radio.Group value={addressType} onChange={this.handleTypeChange}>
                <Radio.Button value="school">校内通讯录</Radio.Button>
                <Radio.Button value="county">局校通讯录</Radio.Button>
                {addressType === 'county' && (
                  <Tooltip
                    className="tip"
                    placement="bottomLeft"
                    overlayClassName="school-address-book-tip"
                    title={
                      <div style={{ paddingTop: '4px' }}>
                        局校通讯录为校内通讯录按照对应规则，展示到教育局的通讯录信息。
                        <br />
                        对应规则：按人员岗位设置进行如下对应
                        <br />
                        <p style={{ fontSize: '14px', marginTop: '8px' }}>
                          · 校级领导（包含如下岗位）：书记、副书记、校长、副校长、调研员、副调研员
                          <br />
                          · 中层干部（包含如下岗位）：正职、副职、财务负责人、安全主任
                          <br />
                          · 收发员（包含如下岗位）：收文员
                          <br />· 教职工：其余所有教职工，不需要设置岗位
                        </p>
                      </div>
                    }
                  >
                    局校通讯录说明
                    <Icon type="question-circle" theme="filled" />
                  </Tooltip>
                )}
              </Radio.Group>
            )}
            {addressType === 'county' && (
              <div className="countyOptions">
                <Select
                  defaultValue={orgStructList[0].name}
                  style={{ width: 120 }}
                  onChange={this.countySelectOptionChange}
                >
                  {orgStructList.map(item => {
                    return <Option value={item.viewDeptId}>{item.name}</Option>;
                  })}
                </Select>
                <Search
                  placeholder="请输入姓名搜索"
                  onSearch={this.countyOnSearch}
                  style={{ width: 200, marginLeft: 20 }}
                />
              </div>
            )}
          </div>
          {addressType === 'school' && <SchoolAddress />}
          {addressType === 'county' && <CountyAddress />}
        </div>
      </Contanner>
    );
  }
}

export default BaseList;
